import { ContainerModule, interfaces } from 'inversify';
import { INotificationsService, NotificationsService } from './services/notifications.service';
import { INotificationsStore, NotificationsStore } from './stores/notifications.store';

export const notificationsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(INotificationsService.$).to(NotificationsService).inSingletonScope();
  bind(INotificationsStore.$).to(NotificationsStore).inSingletonScope();
});
